import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Container } from 'react-bootstrap';
import { usePermissions } from '../context/PermissionsContext';
import { LoadingState } from './PageState';

/**
 * Sends anyone not signed in, or signed in with an account the API refuses, to the login page.
 * The page they asked for travels along as state.from, so Login can return them to it.
 */
const ProtectedRoute = ({ children }) => {
  const { accounts, inProgress } = useMsal();
  const { accessDenied } = usePermissions();
  const location = useLocation();

  if (inProgress !== InteractionStatus.None) {
    return (
      <Container className="py-4">
        <LoadingState label="Signing in" />
      </Container>
    );
  }

  if (accounts.length === 0 || accessDenied) {
    const { pathname, search, hash } = location;
    return <Navigate to="/login" replace state={{ from: { pathname, search, hash } }} />;
  }

  return children;
};

export default ProtectedRoute;
